import { type RichContent, RichContentType } from '@openx/components-core/lib/AiChat/types';
import { AudienceResultsCard } from './AudienceResultsCard';
import { InventoryResultsCard } from './InventoryResultsCard';

type RichContentCardProps = {
  content: RichContent;
  disabled: boolean;
};

export const RichContentCard = ({ content, disabled }: RichContentCardProps) => {
  const commonProps = { disabled };

  if (content.type === RichContentType.AUDIENCE_RESULTS) {
    return <AudienceResultsCard {...commonProps} matches={content.matches} stats={content.stats} />;
  }

  if (content.type === RichContentType.INVENTORY_RESULTS) {
    return <InventoryResultsCard {...commonProps} matches={content.matches} stats={content.stats} />;
  }

  return null;
};
